module.exports = __webpack_public_path__ + "img/kit-medical.0e5f2a26.svg";